import replaceYear from './replaceYear'

export const speakAbleData = (article, location) => ({
  '@context': 'https://schema.org/',
  '@type': 'WebPage',
  name: replaceYear(article.title),
  speakable: {
    '@type': 'SpeakableSpecification',
    cssSelector: ['.mediavineAdsInContent'],
  },
  url: location.href,
})

export default speakAbleData
